// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"787":"bbb46c34200d42475a24","1034":"5373e23b3e57714efa39"}[chunkId] + ".css";
};